import {
  IOgqlColumn,
  IOgqlJobResult,
  IOgqlQueryResult,
  IOgqlV1Column,
  IOgqlV1JobResult,
  IOgqlV1QueryResult
} from '@opengov/ogql-types';
import { IDatasetLensColumn, IReportConfiguration } from '@opengov/reporting-types';
import { IReportColumn } from '@opengov/reporting-types/src/reportColumns-immer';

import { chartActionCreators } from '../../../reportExplorer/ReportVisualization/state';

export const removeHiddenData = (rowData, indicesToFilter) =>
  rowData.map((row) => row.filter((value, i) => !indicesToFilter.includes(i)));

export const indicesOfHiddenColumns = (
  queryColumns:
    | IOgqlQueryResult['columns']
    | IOgqlV1QueryResult['metadata']['columns']
    | IDatasetLensColumn[]
    | IReportColumn[]
): number[] =>
  ((queryColumns as IOgqlQueryResult['columns']) || []).reduce((indices, column: IOgqlColumn | IOgqlV1Column, i) => {
    const hasLabelButNotVisible = (column as IOgqlV1Column).label && !(column as IOgqlV1Column).visible;
    if (
      ((column as IOgqlColumn).metadata &&
        (column as IOgqlColumn).metadata.tags &&
        (column as IOgqlColumn).metadata.tags.hidden) ||
      hasLabelButNotVisible // Lens based columns have no 'hidden' tag, so we check the visible field instead
    ) {
      indices.push(i);
    }
    return indices;
  }, []);

export function respondToVisualizationQuerySuccess(
  jobResult: IOgqlJobResult['jobResult'] | IOgqlV1JobResult['jobResult'],
  setVisualizationResultAndReportConfiguration: typeof chartActionCreators.setVisualizationResultAndReportConfiguration,
  reportConfiguration: IReportConfiguration
): void {
  const columns =
    (jobResult as IOgqlJobResult['jobResult'])?.columns ||
    (jobResult as IOgqlV1JobResult['jobResult'])?.metadata.columns;

  setVisualizationResultAndReportConfiguration({
    visualizationResult: {
      data: jobResult?.data ?? [],
      columns: columns ?? []
    },
    reportConfiguration
  });
}
